import type { Notification } from '@puffin/app-frame-api';
import { create } from 'zustand';
import { getBrowserNotificationPermission } from './browser-notification-permission';

interface NotificationsState {
  notifications: (Notification & { id: string })[];
  dismissNotification: (id: string) => void;
  addNotification: (notification: Notification) => void;
}

const useNotificationsStore = create<NotificationsState>((set) => ({
  notifications: [],
  dismissNotification: (id) => set((state) => ({ notifications: state.notifications.filter((notification) => notification.id !== id) })),
  addNotification: (notification) =>
    set((state) => ({
      notifications: [...state.notifications, { ...notification, id: crypto.randomUUID() }],
    })),
}));

export const useNotifications = () => useNotificationsStore((state) => state.notifications);

export const dismissNotification = (id: string): void => useNotificationsStore.getState().dismissNotification(id);

export const showNotification = (notification: Notification): void => {
  useNotificationsStore.getState().addNotification(notification);
  if (notification.browserNotificationText !== undefined && getBrowserNotificationPermission() === 'granted') {
    try {
      const icon = document.querySelector<HTMLLinkElement>('link[rel~="icon"]')?.href;
      const browserNotification = new window.Notification(notification.browserNotificationText, { requireInteraction: true, icon });
      browserNotification.onclick = () => {
        window.focus();
        browserNotification.close();
      };
    } catch {
      // Some browsers expose Notification but disallow its constructor. The in-app alert remains available.
    }
  }
};
